export const theme = Object.freeze({
    // apply ant design theme
    token: {
        colorPrimary: "#2D5C92",
        // Radio único por densidad: md (botones/inputs/selects) y lg (tarjetas/tablas/modales)
        // ver docs/plan_unificacion_visual.html — sección "Ficha de referencia"
        borderRadius: 8,
        borderRadiusLG: 16,
        colorSuccess: "#7CB342",
        colorWarning: "#FFA726",
        colorError: "#E53935",
        colorInfo: "#42A5F5",
    },
    components: {
        Menu : {
            darkItemHoverBg: "#98BF06",
            itemColor: "#2D5C92",
        },
        Card : {
            // Un solo navy para encabezados de tarjeta (antes: #002455 acá, #023059 y #0A2742 en otros archivos)
            headerBg : "#0A2742",
            headerFontSize: 20,
        },
        Table: {
            headerBg: "#fafafa",
            rowHoverBg: "#F5F8FB",
        },
    }
});